import { render, staticRenderFns } from "./Rbac.vue?vue&type=template&id=ec964620"
import script from "./Rbac.vue?vue&type=script&lang=js"
export * from "./Rbac.vue?vue&type=script&lang=js"
import style0 from "./Rbac.vue?vue&type=style&index=0&id=ec964620&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports